import React, { useState } from 'react';
import { usePopup } from './PopupProvider';
import { apiRequest } from '../utils/apiClient';

const DocumentLinks = ({ endpoint, ownerType, ownerId, documents = [] }) => {
    const { showPopup } = usePopup();
    const [openingField, setOpeningField] = useState('');
    const availableDocuments = documents.filter((document) => document.available);

    const openDocument = async (documentField) => {
        try {
            setOpeningField(documentField);
            const response = await apiRequest(endpoint, {
                method: 'POST',
                body: JSON.stringify({ owner_type: ownerType, owner_id: ownerId, document_field: documentField }),
            });

            if (!response.ok) {
                const data = await response.json().catch(() => ({}));
                throw new Error(data.message || 'Unable to open the document.');
            }

            const fileUrl = URL.createObjectURL(await response.blob());
            const documentWindow = window.open(fileUrl, '_blank');
            if (!documentWindow) {
                URL.revokeObjectURL(fileUrl);
                throw new Error('Your browser blocked the document window. Please allow popups and try again.');
            }
            documentWindow.opener = null;
            window.setTimeout(() => URL.revokeObjectURL(fileUrl), 60000);
        } catch (error) {
            showPopup(error.message || 'Unable to open the document.');
        } finally {
            setOpeningField('');
        }
    };

    if (!availableDocuments.length) {
        return <span className="text-muted">No documents uploaded</span>;
    }

    return (
        <div className="d-flex flex-wrap gap-2">
            {availableDocuments.map((document) => (
                <button key={document.field} type="button" className="btn btn-sm btn-outline-primary" onClick={() => openDocument(document.field)} disabled={openingField === document.field}>
                    {openingField === document.field ? 'Opening...' : document.label}
                </button>
            ))}
        </div>
    );
};

export default DocumentLinks;
